import { render, staticRenderFns } from "./EventCompany.vue?vue&type=template&id=5ae181a6&scoped=true"
import script from "./EventCompany.vue?vue&type=script&lang=ts"
export * from "./EventCompany.vue?vue&type=script&lang=ts"
import style0 from "./EventCompany.vue?vue&type=style&index=0&id=5ae181a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae181a6",
  null
  
)

export default component.exports